module.exports = __webpack_public_path__ + "static/3dmodel07-8c6ddb9db7749338eb930f6584c29600.jpg";